export async function CreateBulkPlansApi(plans) {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}v1/bulk-plan/create-bulk-plans`,
      {
        method: 'POST',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ plans }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating bulk plans:', error);
    return { error: true, message: error.message || 'Failed to create plans' };
  }
}
